const data = [
    {
      id: 1,
      mainAC: "Main00123",
      subAC: "Sub001233",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Remarks: "Policy credit voucher",
      Entry: "Credit",
    },
    {
      id: 2,
      mainAC: "Main00123",
      subAC: "Sub001234",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Remarks: "Policy credit voucher",
      Entry: "Debit",
    },
    {
      id: 3,
      mainAC: "Main00123",
      subAC: "Sub001235",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Remarks: "Policy credit voucher",
      Entry: "Credit",
    },
    {
      id: 4,
      mainAC: "Main00123",
      subAC: "Sub001236",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Remarks: "Policy credit voucher",
      Entry: "Debit",
    },
    {
      id: 5,
      mainAC: "Main00123",
      subAC: "Sub001237",
      Remarks: "Policy credit voucher",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Entry: "Credit",
    },
    {
      id: 6,
      mainAC: "Main00123",
      subAC: "Sub001238",
      Remarks: "Policy credit voucher",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Entry: "Debit",
    },
    {
      id: 7,
      mainAC: "Main00123",
      subAC: "Sub001239",
      Remarks: "Policy credit voucher",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Entry: "Credit",
    },
    {
      id: 8,
      mainAC: "Main00123",
      subAC: "Sub001230",
      Remarks: "Policy credit voucher",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Entry: "Debit",
    },
    {
      id: 9,
      mainAC: "Main00123",
      subAC: "Sub001231",
      Remarks: "Policy credit voucher",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Entry: "Credit",
    },
    {
      id: 10,
      mainAC: "Main00123",
      subAC: "Sub001232",
      Remarks: "Policy credit voucher",
      Currency: "PHP",
      foreignAmount: "500.00",
      localAmount: "50.00",
      Entry: "Debit",
    },
  ];
  export default data;
  